/**
    顶部个人中心组件
*/
<template>
  <div class="TPersonalNav">
    <div class="TPNleft">
      <!-- @click="toOpen('https://www.cnipa.gov.cn/attach/0/0caf8492459846d98f3859ab05225df7.pdf')" -->
      <div class="ty-icon" @click="routLinkTo('/indexpage/index')"></div>
    </div>
    <div class="TPNright">
      <!-- status === 1 -->
      <template v-if="status === 0">
        <!-- 注册/登录 -->
        <div class="content" @click="routLinkTo('/self')">
          <div class="personalText">
            注册/登录
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 个人模块 -->
        <el-dropdown @command="handleCommand" trigger="click">
          <div class="personalText el-dropdown-link">
            {{ userInfo.realName || phoneNum }}
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="user-center">个人中心</el-dropdown-item>
            <el-dropdown-item command="in-out">{{ status === 0 ? '登录' : '退出登录' }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <el-divider direction="vertical"></el-divider>
      <!-- 首页 -->
      <div class="content" @click="routLinkTo('/indexpage/index')">
        <div class="personalText">
          首页
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <!-- 我的订单 -->
      <div class="content" @click="routLinkTo('/userCenter/myOrder')">
        <div class="personalText">
          我的订单
          <Badge class="zxbadge" :num="0" :size="'regular'" />
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <!-- 购物车 -->
      <div class="content" @click="routLinkTo('/cart/shoppingCart')">
        <div class="personalText">
          购物车
          <Badge class="zxbadge" :num="0" :size="'regular'" />
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <!-- 资产分配 -->
      <div class="content" @click="routLinkTo('/userCenter/assetAllocation')">
        <div class="personalText">
          资产分配
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <!-- 下载 -->
      <el-button type="primary" size="mini" @click="toDownload">下载</el-button>
    </div>
  </div>
</template>

<script>
import Badge from '@/components/common/Badge'
import { mapGetters } from 'vuex'
import { getToken, removeToken } from '@/axios/cookies.js'
import { stringHelper } from '@/utils/tool'

export default {
  components: { Badge },
  name: 'TopPersonalNav',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'cartNum', // 购物车商品数量
      'userInfo' // 用户信息
    ]),
    status: {
      get() {
        let result = !getToken() ? 0 : 1
        return result
      }
    },
    phoneNum: {
      get() {
        let num = this.userInfo.phone
        return stringHelper.phoneNumHidden(num, 3, 4)
      }
    }
  },
  created() { },
  methods: {
    routLinkTo(val) {
      if (val === '/vip') { return this.$message.warning('暂未开通会员功能') }
      if (!val || val === this.$route.path) {
        location.reload()
      } else {
        this.$router.push(val)
      }
    },
    handleCommand(command) {
      console.log(command, 'command')
      if (command === 'user-center') {
        // 用户中心
        this.$router.push('/userCenter')
      } else if (command === 'in-out') {
        if (this.status === 1) {
          // 退出
          removeToken()
          this.$store.commit('reset')
          console.log('退出')
          this.routLinkTo('/indexpage/index')
        } else {
          // 登录
          this.$store.commit('setLoginVisible', true)
          console.log('退出')
          this.$router.push('/self/login')
        }
      }
    },
    toDownload() {
      let link = this.$router.resolve({ path: '/agreement/download' })
      location.href = link.href
      // window.open(link.href, '_blank')
    },
    toOpen(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss">
.TPersonalNav {
  $height: 61px;
  $line-height: 30px;

  width: $width;
  height: $height;
  padding: 15px 20px;
  line-height: $line-height;
  background-color: #003d88;
  border-bottom: 1px solid rgba(248, 248, 248, 0.25);
  position: fixed;
  top: 0;
  z-index: 1998;
  left: calc(50% - $width / 2);

  div {
    display: inline-block;
  }

  .TPNleft {
    height: 100%;
    margin-left: 25px;
    // cursor: pointer;

    .ty-icon {
      width: 131px;
      height: 30px;
      background-image: url('/static/images/TPersonalNav/ty-icon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }

  .TPNright {
    height: 30px;
    float: right;
    margin-right: 250px;
    cursor: pointer;

    .personalText {
      font-size: 12px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.76);

      .zxbadge {
        display: inline-block;
        height: 20px;
        position: relative;
        left: -5px;
      }
    }

    .el-divider {
      background-color: #fff;
      opacity: 0.26;
    }

    .el-divider--vertical {
      height: 10px;
    }

    .el-button {
      width: 68px;
      height: 30px;
      border: 1px solid #FFFFFF;
      border-radius: 8px;
      color: #FFFFFF;
      background: transparent;
    }
  }

  &:hover {
    background-color: #FFFFFF;

    .TPNleft {
      .ty-icon {
        background-image: url('/static/images/TPersonalNav/ty-icon1.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }

    .personalText {
      font-size: 12px;
      font-weight: 500;
      color: rgba(51, 51, 51, 0.76);
    }

    .el-divider {
      background-color: #333;
      opacity: 0.26;
    }

    .el-button {
      color: #FFFFFF;
      background: linear-gradient(90deg, #2088D1, #8FEADA);

      &:hover {
        background-color: #1a5194;
      }
    }
  }

  >>>.el-dropdown-menu__item {
    text-align: center;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    color: #333333;
  }

  >>>.el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #F6F6F6;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/TopPersonalNav.vue